import {Component, Input} from '@angular/core';
import {CfSuite, CfTask} from "@app-web-central/web/shared/data-access/models";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'as-task-drawer-suite',
  templateUrl: './task-drawer-suite.component.html',
  styleUrls: ['./task-drawer-suite.component.scss'],
})
export class TaskDrawerSuiteComponent {
  @Input() task!: CfTask;
  @Input() suites!: CfSuite[];
  @Input() control!: FormControl;

  onSelectSuite(suite: CfSuite | null) {
    this.control.setValue(suite);
  }

}
